import { render, staticRenderFns } from "./broker.vue?vue&type=template&id=06068846&scoped=true&"
import script from "./broker.vue?vue&type=script&lang=ts&"
export * from "./broker.vue?vue&type=script&lang=ts&"
import style0 from "./broker.vue?vue&type=style&index=0&id=06068846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06068846",
  null
  
)

export default component.exports